import { Tag, RotateCcw } from 'lucide-react';
import React, { useState } from 'react';

import { FilterGroup, FilterButton } from './';

/**
 * ModuleFilters - Generic Sidebar for Navigation and Filtering.
 * Supports multiple sections with custom buttons and behavior.
 */
const EMPTY_SECTIONS = [];

const ModuleFilters = ({
    sections = EMPTY_SECTIONS, // Array of { id, label, icon, buttons: [{ id, label, subLabel, icon, count, active, onClick, ... }] }
    onReset = null,
    hasActiveFilters = false,
    headerIcon: HeaderIcon = Tag,
    headerTitle = "Technical Filters",
    expandedIds,
    onExpandedChange
}) => {
    const [localExpanded, setLocalExpanded] = useState(() => [sections[0]?.id].filter(Boolean));

    const activeExpanded = expandedIds !== undefined ? expandedIds : localExpanded;

    const handleToggle = (sectionId) => {
        const isCurrentlyExpanded = activeExpanded.includes(sectionId);
        const newExpanded = isCurrentlyExpanded
            ? activeExpanded.filter(id => id !== sectionId)
            : [...activeExpanded, sectionId];

        if (onExpandedChange) {
            onExpandedChange(newExpanded);
        } else {
            setLocalExpanded(newExpanded);
        }
    };

    return (
        <aside className="flex flex-col animate-in fade-in slide-in-from-left-4 duration-500">
            {/* {headerTitle && (
                <div className="h-11 mb-2 shrink-0 flex items-center gap-3 px-1 sticky top-0 bg-slate-50/95 backdrop-blur-sm z-20 pt-4 -mt-4">
                    <HeaderIcon size={20} className="text-primary" strokeWidth={2.5} />
                    <h3 className="font-black text-primary text-sm tracking-widest uppercase italic pr-2">
                        {headerTitle}
                    </h3>
                </div>
            )} */}

            {sections.map((section) => (
                <FilterGroup
                    key={section.id}
                    label={section.label}
                    icon={section.icon}
                    isExpanded={activeExpanded.includes(section.id)}
                    onToggle={() => handleToggle(section.id)}
                    hideItemArrows={section.hideItemArrows}
                >
                    {section.buttons.map((btn) => (
                        <FilterButton
                            key={btn.id}
                            {...btn}
                            activeClass={btn.activeClass || "bg-primary border-primary text-white"}
                            iconColor={btn.iconColor || "text-slate-400"}
                            activeIconColor={btn.activeIconColor || "bg-white/20 text-accent"}
                        />
                    ))}
                </FilterGroup>
            ))}

            {onReset && hasActiveFilters && (
                <div className="flex flex-col border-t border-slate-200 pt-5">
                    <button
                        onClick={onReset}
                        className="flex items-center justify-center gap-3 w-full py-3 bg-white border border-slate-200 rounded-2xl text-slate-400 hover:text-primary transition-all active:scale-95 group shadow-sm hover:shadow-md"
                    >
                        <RotateCcw size={14} className="group-hover:-rotate-180 transition-transform duration-700" />
                        <span className="text-[10px] font-black uppercase tracking-widest text-primary italic">
                            Clear All Filters
                        </span>
                    </button>
                </div>
            )}
        </aside>
    );
};

export default ModuleFilters;
